// apps/web/src/features/russia-requests/components/editor/EditorPrimitives.tsx
//
// Tiny presentational primitives shared by the russia-rates editor cards.
// Centralized so the cards stay focused on field logic and the styles do
// not drift across cards.

import type { CSSProperties, ReactNode } from 'react';

export function Card({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section
      style={{
        border: '1px solid var(--border-1)',
        borderRadius: 8,
        padding: '12px 16px',
        marginBottom: 12,
        background: 'var(--bg-1)',
      }}
    >
      <h3
        style={{
          margin: '0 0 10px',
          fontSize: 13,
          fontWeight: 600,
          color: 'var(--fg-2)',
          textTransform: 'uppercase',
          letterSpacing: '0.4px',
        }}
      >
        {title}
      </h3>
      {children}
    </section>
  );
}

export function Field({
  label,
  htmlFor,
  error,
  children,
}: {
  label: string;
  htmlFor?: string;
  error?: string | null;
  children: ReactNode;
}) {
  return (
    <div style={{ marginBottom: 12 }}>
      <label
        htmlFor={htmlFor}
        style={{ display: 'block', fontSize: 12, fontWeight: 500, marginBottom: 4 }}
      >
        {label}
      </label>
      {children}
      {error && (
        <p
          role="alert"
          style={{ color: 'var(--status-error-fg)', fontSize: 12, margin: '4px 0 0' }}
        >
          {error}
        </p>
      )}
    </div>
  );
}

export const inputStyle: CSSProperties = {
  width: '100%',
  padding: '6px 10px',
  fontSize: 13,
  border: '1px solid var(--border-1)',
  borderRadius: 4,
  background: 'var(--bg-0)',
  color: 'var(--fg-1)',
};

export const chipStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 8px',
  border: '1px solid var(--border-1)',
  borderRadius: 12,
  fontSize: 13,
  background: 'var(--bg-2)',
};
